import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import DashboardLeaveTrend from "./DashboardLeaveTrend";

export default function DashboardSafeLeavesTrend() {
    const leaves = useSelector((state) => state.leaves.myList);
    const userId = useSelector((state) => state.login.userId);

    const myLeaves = useMemo(() => {
        if (!leaves || !leaves.length) return [];
        if (!userId) return leaves;
        const filtered = leaves.filter((leave) => String(leave.id_collab) === String(userId));
        return filtered.length ? filtered : leaves;
    }, [leaves, userId]);

    return (
        <DashboardLeaveTrend
            leaves={myLeaves}
            title="Mes absences"
            subtitle="Sur 6 mois"
            monthsCount={6}
            emptyLabel="Aucune absence récente"
        />
    );
}

